import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { Button, Field } from "@bwevents/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./InputSearch.scss";

export default function InputSearch({ initialValue }) {
  const [searchParam] = useSearchParams();
  const searchValue = searchParam.get("search");

  const navigate = useNavigate();
  const [search, setSearch] = useState(initialValue || searchValue);

  const searchSubmit = (value) => {
    if (value && value.length > 0) {
      navigate(`/search?search=${value}`);
    }
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        searchSubmit(event.target.value);
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  });

  return (
    <div className="wrapper-input-search">
      <div className="input-search">
        <FontAwesomeIcon
          className="input-search-icon"
          icon={faMagnifyingGlass}
          style={{ color: "#9E9E9E" }}
          onClick={() => searchSubmit(search)}
        />
        <Field
          type="text"
          placeholder="Search any events or videos"
          value={search}
          setValue={setSearch}
          className="bw-event-input input-search-field"
        />
        <Button
          className="bw-event-btn input-search-btn"
          label="Search"
          onClick={() => searchSubmit(search)}
        />
      </div>
    </div>
  );
}
